import { useParams } from 'react-router-dom';

import { ExportChecklistPage } from 'src/Containers/Exports/ExportPage/ExportChecklistPage';
import { ExportContactPage } from 'src/Containers/Exports/ExportPage/ExportContactPage';
import { ExportFilesPage } from 'src/Containers/Exports/ExportPage/ExportFilesPage';
import { ExportInstructionPage } from 'src/Containers/Exports/ExportPage/ExportInstructionPage';
import { ExportPlanningPage } from 'src/Containers/Exports/ExportPage/ExportPlanningPage';
import { ExportPracticalInformationPage } from 'src/Containers/Exports/ExportPage/ExportPracticalInformationPage';
import useFetchExportMetadata from 'src/Hooks/Queries/useFetchExportMetadata';
import { ExportWithEntitiesDtoEntityTypeEnum } from 'src/Services/API/generated';

import styles from './ExportPage.module.scss';

type ExportParams = {
  token: string;
};

const ExportPage = () => {
  const { token } = useParams<ExportParams>();
  const { data } = useFetchExportMetadata(token);

  return (
    token && (
      <div className={styles.container}>
        {data?.entityType === ExportWithEntitiesDtoEntityTypeEnum.Contact && (
          <ExportContactPage token={token} />
        )}
        {data?.entityType === ExportWithEntitiesDtoEntityTypeEnum.Checklist && (
          <ExportChecklistPage token={token} />
        )}
        {data?.entityType === ExportWithEntitiesDtoEntityTypeEnum.Instruction && (
          <ExportInstructionPage token={token} />
        )}
        {data?.entityType === ExportWithEntitiesDtoEntityTypeEnum.Event && (
          <ExportPlanningPage token={token} />
        )}
        {data?.entityType === ExportWithEntitiesDtoEntityTypeEnum.AssetStorageItem && (
          <ExportFilesPage token={token} />
        )}
        {data?.entityType === ExportWithEntitiesDtoEntityTypeEnum.PracticalInformation && (
          <ExportPracticalInformationPage token={token} />
        )}
      </div>
    )
  );
};

export default ExportPage;
